// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GlobalSearch_wrapper__m8nKC","results":"GlobalSearch_results__aFeqR","shortcutHint":"GlobalSearch_shortcutHint__fT0ke"};